import {useContext, createContext, useState} from 'react'

const MailchimpModalContext = createContext()

export const MailchimpModalContextProvider = ({children}) => {
    const [isOpenMailchimpModal, setIsOpenMailchimpModal] = useState(null)
    return (
        <MailchimpModalContext.Provider value={{isOpenMailchimpModal, setIsOpenMailchimpModal}}>{children}</MailchimpModalContext.Provider>
    )
}

export const MailchimpModalActions = () => {
    return useContext(MailchimpModalContext)
}